import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import {
  getAuth,
  // connectAuthEmulator,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBJ9J9D5Qb8RWbmjwcbqHQNxtrOs8MCnPA",
  authDomain: "tunepicker-59159.firebaseapp.com",
  projectId: "tunepicker-59159",
  storageBucket: "tunepicker-59159.appspot.com",
  messagingSenderId: "575985420793",
  appId: "1:575985420793:web:11beb15eb6ea87ad99d528"
};

const firebaseApp = initializeApp(firebaseConfig);

const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);
//connectAuthEmulator(auth, "http://localhost:9099/");

export {
  firebaseApp,
  db,
  auth
};